async function clientPull(serverUrl, token, command, data) {
	try {
		let res = await fetch(serverUrl + "/api/sync/clientPull", {
			method: "post",
			headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
			body: JSON.stringify({ command, data })
		});

		let json = await res.json();
		return json;
	} catch (error) {
		console.log(error);
	}
}

export default clientPull;
